import { Logo } from "@/components/landing/Logo";

export const FullScreenLoader = ({ label = "Loading" }) => {
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center bg-[#0A0A0A]"
      data-testid="fullscreen-loader"
    >
      <Logo className="text-3xl" />
      <div className="mt-8 flex items-center gap-2">
        <span className="h-2 w-2 animate-bounce rounded-full bg-[#E52525] [animation-delay:-0.3s]" />
        <span className="h-2 w-2 animate-bounce rounded-full bg-[#E52525] [animation-delay:-0.15s]" />
        <span className="h-2 w-2 animate-bounce rounded-full bg-[#E52525]" />
      </div>
      <p className="mt-5 text-sm font-medium tracking-wide text-zinc-500">
        {label}
      </p>
    </div>
  );
};
